module.exports = __webpack_public_path__ + "img/minigolf.79d6f0f0.svg";